module.exports = __webpack_public_path__ + "static/hollywood-4b8038bf070bc18197d2b58ce89c40ef.png";